import React, { useState } from "react";
import "./Media.css";

const Media = () => {
  const [activeTab, setActiveTab] = useState("photos");
  const [selectedImage, setSelectedImage] = useState(null);

  // Sample gallery data - in a real app, this would come from an API
  const photos = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&fit=crop",
      alt: "Craft cocktail with garnish",
      category: "cocktails",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1514362545857-3bc1c0d2fea5?w=400&fit=crop",
      alt: "Bartender mixing drinks",
      category: "service",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1546173159-315724a31696?w=400&fit=crop",
      alt: "Wedding reception bar setup",
      category: "events",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=400&fit=crop",
      alt: "Corporate event bartending",
      category: "events",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=400&fit=crop",
      alt: "Signature cocktail menu",
      category: "cocktails",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=400&fit=crop",
      alt: "Private party setup",
      category: "service",
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1566733971017-fc4277d0b5c9?w=400&fit=crop",
      alt: "Premium spirits selection",
      category: "cocktails",
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&fit=crop",
      alt: "Event bartending service",
      category: "service",
    },
    {
      id: 9,
      src: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=400&fit=crop",
      alt: "Large event setup",
      category: "events",
    },
  ];

  const videos = [
    {
      id: 1,
      title: "Craft Cocktail Making Process",
      description: "Watch our expert bartenders create signature cocktails",
      embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    },
    {
      id: 2,
      title: "Wedding Bartending Service",
      description: "See how we set up and serve at wedding receptions",
      embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    },
    {
      id: 3,
      title: "Corporate Event Highlights",
      description: "Professional bartending for corporate functions",
      embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    },
  ];

  const socialPosts = [
    {
      id: 1,
      platform: "Instagram",
      username: "@craftcocktails",
      content:
        "Amazing wedding reception last night! The signature cocktail was a huge hit 🍸✨ #weddingbartending #craftcocktails",
      likes: 234,
      comments: 18,
    },
    {
      id: 2,
      platform: "Facebook",
      username: "Craft Cocktails",
      content:
        "Corporate event success! Our team served 200+ guests with custom cocktails. Thank you for choosing us! 🥂",
      likes: 156,
      comments: 12,
    },
    {
      id: 3,
      platform: "Twitter",
      username: "@craftcocktails",
      content:
        'New signature cocktail alert! The "Golden Sunset" featuring local honey and fresh citrus 🍯🍊 #mixology #local',
      likes: 89,
      comments: 7,
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState("all");

  const filteredPhotos =
    selectedCategory === "all"
      ? photos
      : photos.filter((photo) => photo.category === selectedCategory);

  return (
    <div className="media-page">
      <div className="container">
        <div className="media-header">
          <h1>Our Gallery</h1>
          <p>Take a look at our work, events, and behind-the-scenes moments</p>
        </div>

        <div className="media-tabs">
          <button
            className={`tab-button ${activeTab === "photos" ? "active" : ""}`}
            onClick={() => setActiveTab("photos")}
          >
            📸 Photos
          </button>
          <button
            className={`tab-button ${activeTab === "videos" ? "active" : ""}`}
            onClick={() => setActiveTab("videos")}
          >
            🎥 Videos
          </button>
          <button
            className={`tab-button ${activeTab === "social" ? "active" : ""}`}
            onClick={() => setActiveTab("social")}
          >
            📱 Social Media
          </button>
        </div>

        <div className="media-content">
          {activeTab === "photos" && (
            <div className="photos-section">
              <div className="category-filters">
                <button
                  className={`filter-btn ${
                    selectedCategory === "all" ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory("all")}
                >
                  All
                </button>
                <button
                  className={`filter-btn ${
                    selectedCategory === "cocktails" ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory("cocktails")}
                >
                  Cocktails
                </button>
                <button
                  className={`filter-btn ${
                    selectedCategory === "service" ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory("service")}
                >
                  Service
                </button>
                <button
                  className={`filter-btn ${
                    selectedCategory === "events" ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory("events")}
                >
                  Events
                </button>
              </div>

              <div className="photo-gallery">
                {filteredPhotos.map((photo) => (
                  <div
                    key={photo.id}
                    className="photo-item"
                    onClick={() => setSelectedImage(photo)}
                  >
                    <img
                      src={photo.src}
                      alt={photo.alt}
                      onError={(e) => {
                        e.target.src =
                          "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&fit=crop";
                        e.target.alt = "Bartending service";
                      }}
                    />
                    <div className="photo-overlay">
                      <p>{photo.alt}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "videos" && (
            <div className="videos-section">
              <div className="video-grid">
                {videos.map((video) => (
                  <div key={video.id} className="video-item">
                    <div className="video-container">
                      <iframe
                        src={video.embedUrl}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                    <div className="video-info">
                      <h3>{video.title}</h3>
                      <p>{video.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "social" && (
            <div className="social-section">
              <div className="social-grid">
                {socialPosts.map((post) => (
                  <div key={post.id} className="social-post">
                    <div className="post-header">
                      <div className="platform-icon">
                        {post.platform === "Instagram"
                          ? "📷"
                          : post.platform === "Facebook"
                          ? "📘"
                          : "🐦"}
                      </div>
                      <div className="post-meta">
                        <h4>{post.username}</h4>
                        <span className="platform-name">{post.platform}</span>
                      </div>
                    </div>
                    <div className="post-content">
                      <p>{post.content}</p>
                    </div>
                    <div className="post-stats">
                      <span>❤️ {post.likes}</span>
                      <span>💬 {post.comments}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <h3>{selectedImage.alt}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Media;
